export const mockupTipo = [
  { name: "50%" },
  { name: "100%" },
  { name: "Feriado" },
  { name: "Día gremio" },
];
